'use client';

import Link from '@eliadmin/core/src/components/link';

import { GeneralLayout, Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { GoLocation } from 'react-icons/go';
import { MdOutlineMail, MdOutlinePhoneInTalk } from 'react-icons/md';

export function FooterMobileAccordions({
  generalLayout,
  menu,
}: {
  generalLayout: GeneralLayout['data'];
  menu: Menu[];
}) {
  return (
    <Accordion type="multiple" className="flex w-full flex-col items-start justify-start sm:hidden">
      {menu.map((menu, index) => (
        <AccordionItem
          key={menu.name}
          value={menu.name}
          className={cn(
            'w-full',
            'ea-footer-mobile__accordion-item',
            index === 0 && 'border-t-0 pt-0',
          )}
        >
          <AccordionTrigger className={cn('ea-footer-mobile__accordion-trigger')}>
            <span className="h5 font-medium tracking-tighter text-black">{menu.name}</span>
          </AccordionTrigger>
          <AccordionContent
            className={cn(
              'ea-footer-mobile__accordion-content',
              'flex flex-col items-start justify-start gap-3',
            )}
          >
            {menu.fields.map(field => (
              <Link
                href={getSafeHref(field?.path ?? '')}
                key={field.name}
                prefetchOnHover
                className="text-sm tracking-tight"
              >
                {field.name}
              </Link>
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
      <AccordionItem
        value="contact"
        className={cn('w-full border-b', 'ea-footer-mobile__accordion-item')}
      >
        <AccordionTrigger className={cn('ea-footer-mobile__accordion-trigger')}>
          <span className="h5 font-medium tracking-tighter text-black">Kontaktné údaje</span>
        </AccordionTrigger>
        <AccordionContent
          className={cn(
            'ea-footer-mobile__accordion-content',
            'flex flex-col items-start justify-start gap-3',
          )}
        >
          <Paragraph size="base" className="w-full text-left">
            <strong className="font-bold">Infolinka</strong>&nbsp;
            <span className="text-[#6B7280]">(9:00 - 18:00)</span>
          </Paragraph>
          <Link
            prefetch={false}
            href={`tel:${generalLayout?.contact?.phone}`}
            className="flex items-center justify-start gap-2 text-sm transition-all hover:opacity-80 lg:text-base"
            target="_blank"
          >
            <MdOutlinePhoneInTalk size={20} className="text-primary" />
            {generalLayout?.contact?.phone}
          </Link>
          <Link
            prefetch={false}
            href={`mailto:${generalLayout?.contact?.email}`}
            className="flex items-center justify-start gap-2 text-sm transition-all hover:opacity-80 lg:text-base"
            target="_blank"
          >
            <MdOutlineMail size={20} className="text-primary" />
            {generalLayout?.contact?.email}
          </Link>
          <Link
            prefetch={false}
            href={'https://share.google/IsRDvDPpsL53rRSYb'}
            className="flex items-start justify-start gap-2 text-sm transition-all hover:opacity-80 lg:text-base"
            target="_blank"
          >
            <GoLocation size={20} className="text-primary" />
            {generalLayout?.contact?.address}
            <br />
            {generalLayout?.contact?.postcode} {generalLayout?.contact?.city}
          </Link>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
